import * as React from 'react';

function SvgAvatarDefault(props) {
  return (
    <svg width={72} height={72} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M72 36c0 19.882-16.118 36-36 36C16.117 72 0 55.882 0 36 0 16.117 16.117 0 36 0c19.882 0 36 16.117 36 36z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.667 45.333c.765 7.417 0 17.334 0 17.334h22.666s-1.233-9.242 0-17.334"
        fill="#4C4C4C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.518 66.927c.207-1.287.25-2.066.54-3.06.543-1.869 1.483-3.702 2.873-4.448 2.184-1.173 4.282-1.952 7.901-2.752.738 1.418 3.166 3.237 7.182 3.2 4.017-.037 6.465-1.253 7.183-3.2 3.069.98 5.725 2.108 6.948 2.752 1.88.988 3.233 2.474 3.76 4.448.188.71.448 1.758.673 3.06-5.457 3.017-10.91 4.96-18.632 5.07-7.722.108-13.556-2.314-18.428-5.07z"
        fill="#FCCE01"
      />
      <path fill="#FFDDCA" d="M32 49.333h8V60h-8z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.809 37.035c0-2.341-2.644-17.702 14.858-17.702 17.501 0 14.857 15.282 14.857 17.702 0 10.246-7.82 15.632-14.857 15.632-7.038 0-14.858-6.572-14.858-15.632z"
        fill="#FFEDE3"
      />
      <ellipse cx={20.667} cy={40.667} rx={2} ry={4} fill="#FFEDE3" />
      <ellipse
        cx={2}
        cy={4}
        rx={2}
        ry={4}
        transform="matrix(-1 0 0 1 52.667 36.667)"
        fill="#FFEDE3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.667 36c0 1.473-.97 2.667-2.167 2.667-1.196 0-2.167-1.194-2.167-2.667 0-1.473.97-2.667 2.167-2.667 1.196 0 2.167 1.194 2.167 2.667zM42.5 33.333c1.196 0 2.167 1.194 2.167 2.667 0 1.473-.97 2.667-2.167 2.667-1.196 0-2.167-1.194-2.167-2.667 0-1.473.97-2.667 2.167-2.667z"
        fill="#4C4C4C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.477 42.689c.293-.662-.209-1.356-.933-1.356h-9.088c-.724 0-1.226.694-.933 1.356.822 1.855 2.623 4.96 5.477 4.96s4.656-3.105 5.477-4.96z"
        fill="#F6B58E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.66 12.667c8.045 0 19.213 6.89 15.662 22.343-.246 1.071-.726 1.017-.79 2.212 0 0-1.552-11.984-5.753-14.105-4.37-2.206-4.298 2.121-9.163 2.121-4.866 0-5.394-4.298-9.386-2.12-3.888 2.12-3.888 11.494-4.456 14.104-.5 2.293-1.136-1.21-1.136-1.21C15.39 19.556 27.1 12.666 35.66 12.666z"
        fill="#4C4C4C"
      />
      <path
        d="M21.869 36.61c.499 4.776 2.587 7.7 6.294 8.877a.539.539 0 01-.326 1.026c-4.143-1.315-6.499-4.613-7.04-9.79a.539.539 0 011.072-.112z"
        fill="#4C4C4C"
      />
      <ellipse cx={28.667} cy={45.667} rx={2} ry={1.667} fill="#4C4C4C" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.958 54.667L36 60.09l-4.128 2.576L28 56.573l3.958-1.906zM40.042 54.667L36 60.09l4.128 2.576L44 56.573l-3.958-1.906z"
        fill="#F9F6F2"
      />
      <ellipse cx={36.333} cy={12.333} rx={7} ry={2.333} fill="#4C4C4C" />
    </svg>
  );
}

export default SvgAvatarDefault;
